export default {
	common: {
		banner: {
			subText: 'Commencez ou continuez votre questionnaire en ligne.',
			signup: 'Créer un compte',
			signin: 'Se connecter'
		},
		accessInstruction: {
			title: 'Vous n’avez pas reçu votre code d’accès par courrier ?',
			hasAccount: 'Vous avez déjà un compte',
			noAccount: 'Vous n’avez pas encore de compte'
		},
		howItWorks: {
			title: 'Comment ça marche ?',
			info: 'Les délais à respecter sont précisés dans le questionnaire accessible depuis votre compte'
		},
		icons: {
			signup: 'Je créé un compte',
			answer: 'Je réponds au questionnaire et ajoute des documents',
			comment: 'J\'ajoute des commentaires sur les documents',
			decision: 'Je reçois la décision de la caisse primaire d\'assurance maladie'
		},
		help: {
			title: 'Besoin d\'aide ?',
			moreInformation: 'Plus d\'information sur',
			phone: 'Ou par téléphone au'
		},
		faq: {
			qr1: {
				question: 'Vous vous êtes déjà inscrit sur QRP et vous n’avez pas reçu de courrier comportant un code de déblocage ?',
				answer: 'Vous n’avez pas besoin de vous réinscrire à nouveau. Utilisez votre compte pour pouvoir accéder aux nouveaux dossiers.'
			},
			qr2: {
				question: 'Vous ne vous êtes jamais inscrit sur QRP et vous n’avez pas reçu de courrier comportant un code de déblocage ?',
				answer: 'Le code de déblocage est envoyé par courrier dans les 10 jours suivants votre demande. Si vous ne l’avez pas reçu ou pour faire une demande de code de déblocage, veuillez contacter le 36 79'
			}
		}
	},
	employeur: {
		bannerLabel: 'En tant qu\'employeur',
		title: 'Un(e) de vos salarié(e)s a une déclaration d\'accident de travail ou de maladie professionnelle en cours',
		howItWorks: {
			subTitle: 'Ce questionnaire permet de fournir à la caisse d\'assurance maladie, l\'ensemble des éléments nécessaires à l\'étude du dossier de votre salarié(e)'
		},
		informations: {
			title: 'Le questionnaire risques professionnels est maintenant disponible sur votre Compte entreprise',
			first: {
				firstPart: '1. Il n\'y a plus besoin de s\'inscrire',
				secondPart: 'Pour compléter ou consulter un dossier il suffit de vous connecter à votre Compte Entreprise et d’accéder au service Questionnaire Risques Professionnels',
				thirdPart: '("Pour pouvoir accéder aux questionnaires, vous devez être habilité au service «DAT: Déclaration d’accident de travail ou de trajet». Dans le cas contraire, il vous suffit de demander l’habilitation sur net-entreprises.fr. L’accès vous sera donné dans un délai maximum de deux jours.")'
			},
			second: {
				firstPart: '2. Vous avez reçu un code d’accès pour vous inscrire à QRP',
				secondPart: 'merci de ne pas prendre en compte ce courrier. L’accès au questionnaire risques professionnels et vos dossiers s’effectue maintenant depuis votre Compte Entreprise'
			}
		},
		icons: {
			signup: 'Je me connecte à mon compte entreprise  depuis <a href="https://net-entreprises.fr">net-entreprises.fr</a>',
			folder: 'J\'ai accès à toutes les pièces du dossier'
		}
	},
	'employeur-particulier': {
		bannerLabel: 'En tant qu\'employeur particulier',
		title: 'Un(e) de vos salarié(e)s a une déclaration d\'accident de travail ou de maladie professionnelle en cours',
		howItWorks: {
			subTitle: 'Ce questionnaire permet de fournir à la caisse d\'assurance maladie, l\'ensemble des éléments nécessaires à l\'étude du dossier de votre salarié(e)'
		},
		accessInstruction: 'Vous allez recevoir un code d’accès par courrier dans les 10 jours suivant le début d’instruction de votre dossier. Si vous ne l’avez pas reçu veuillez contacter le 3679.',
		icons: {
			folder: 'J\'ai accès à toutes les pièces du dossier tout comme l\'assuré(e)'
		}
	},
	assure: {
		bannerLabel: 'En tant que salarié(e)',
		title: 'Vous avez une déclaration d\'accident de travail ou de maladie professionnelle en cours',
		howItWorks: {
			subTitle: 'Ce questionnaire permet de fournir à votre caisse d\'assurance maladie, l\'ensemble des éléments nécessaires à l\'étude de votre dossier'
		},
		hasAccount: 'connectez-vous directement pour accéder à tous vos dossiers.',
		noAccount: 'vous allez recevoir un code d’accès par courrier dans les 10 jours suivant le début d’instruction de votre dossier. Si vous ne l’avez pas reçu veuillez contacter le 3646.',
		icons: {
			folder: 'J\'ai accès à toutes les pièces du dossier tout comme mon employeur'
		}
	}
};
